const Home = () => {
  return (
    <section className="w-full bg-black text-white px-2 md:px-8">
      <div className="max-w-[1500px] mx-auto min-h-[85vh] flex flex-col lg:flex-row items-center gap-12 lg:gap-20 py-20 px-4 md:px-12">
        {/* Left — Identity */}
        <div className="flex-1 flex flex-col gap-6">
          <div className="flex items-center gap-4 reveal-left">
            <div className="w-12 h-[3px] bg-orange-600 line-grow delay-200" />
            <span className="text-xs font-bold uppercase tracking-[0.3em] text-gray-400">
              Fullstack Engineer
            </span>
          </div>
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-black uppercase tracking-tighter leading-[0.85] reveal-up delay-100">
            Matteo
            <br />
            Aries
            <span className="text-orange-600">.</span>
          </h1>
          <div className="flex items-center gap-5 mt-4 reveal-up delay-300">
            <a
              href="https://github.com/Smagia"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 border-3 border-white shadow-[3px_3px_0px_0px_#fff] hover:shadow-[3px_3px_0px_0px_#ea580c] hover:border-orange-600 transition-all duration-200"
              aria-label="GitHub"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
              </svg>
            </a>
            <a
              href="https://www.linkedin.com/in/ariesmatteo/"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 border-3 border-white shadow-[3px_3px_0px_0px_#fff] hover:shadow-[3px_3px_0px_0px_#ea580c] hover:border-orange-600 transition-all duration-200"
              aria-label="LinkedIn"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
              </svg>
            </a>
            <a
              href="mailto:ariesmatteo@gmail.com"
              className="p-2 border-3 border-white shadow-[3px_3px_0px_0px_#fff] hover:shadow-[3px_3px_0px_0px_#ea580c] hover:border-orange-600 transition-all duration-200"
              aria-label="Email"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="4" width="20" height="16" rx="2" />
                <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
              </svg>
            </a>
          </div>
        </div>

        {/* Right — Manifesto + metadata */}
        <div className="lg:w-[480px] shrink-0 flex flex-col gap-8">
          <div className="border-l-3 border-orange-600 pl-6 reveal-right delay-300">
            <p className="text-lg md:text-xl leading-snug font-bold">
              I design and ship complete production systems —
              from React frontends to NestJS backends,
              from database schema to deployment pipeline.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-6 reveal-up delay-500">
            <div>
              <p className="text-[10px] font-bold uppercase tracking-[0.25em] text-gray-500 mb-1">
                Focus
              </p>
              <p className="text-sm font-bold">
                Web Systems, Architecture, Product Engineering
              </p>
            </div>
            <div>
              <p className="text-[10px] font-bold uppercase tracking-[0.25em] text-gray-500 mb-1">
                Stack
              </p>
              <p className="text-sm font-bold">
                TypeScript / React / NestJS / Java / Spring Boot
              </p>
            </div>
            <div>
              <p className="text-[10px] font-bold uppercase tracking-[0.25em] text-gray-500 mb-1">
                Based In
              </p>
              <p className="text-sm font-bold">Switzerland</p>
            </div>
            {/* <div>
              <p className="text-[10px] font-bold uppercase tracking-[0.25em] text-gray-500 mb-1">
                Available
              </p>
              <p className="text-sm font-bold text-orange-500">Open to work</p>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;
